module.exports = __webpack_public_path__ + "static/img/6.80a56e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/zombs/6.png
// module id = UZx0
// module chunks = 35